import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.match";
import { getQueryString, log, parseDate, syncXhr } from "./util";
function setSettingData(data) {
  window.__SettingData__ = data;
}
function getSettingData() {
  return window.__SettingData__;
}
var settingCgiHost = location.host === 'film.video.qq.com' ? 'film.video.qq.com' : 'film.qq.com';
// 支持预览模式，工具预览id请求预览配置，替换默认的配置
function checkPreview() {
  var previewId = getQueryString('__SettingPreviewId__');
  // 支持预览逻辑
  if (previewId) {
    var data = syncXhr("//".concat(settingCgiHost, "/x/autovue/setting-cgi/route/preview/").concat(previewId));
    if (data) {
      setSettingData(data);
    } else {
      alert('没有帮你找到预览的配置数据！请联系项目负责人！');
    }
  }
}

/**
 * 从script里的src值中获取settingId
 * @returns setttingId
 */
function getSettingId() {
  // 找到src里包含'setting-cgi'的script元素
  var scriptElem = document.querySelector('script[src*="setting-cgi"]');
  if (!scriptElem) {
    return '';
  }
  var matched = scriptElem.src.match(/setting-cgi\/route\/script\/(\d+)/);
  if (matched) {
    return matched[1];
  }
  return '';
}

/**
 * 检查并更新缓存
 */
function checkCache() {
  var settingId = getSettingId();
  if (!settingId) return;
  var cacheKey = 'setting_' + settingId;
  if (getSettingData()) {
    localStorage && localStorage.setItem(cacheKey, JSON.stringify(getSettingData()));
  } else {
    // 拉取失败，尝试从localStorage中获取上一次的配置
    var cachedData = localStorage && localStorage.getItem(cacheKey);
    if (cachedData) {
      log('have_cached_data', settingId);
      try {
        setSettingData(JSON.parse(cachedData));
      } catch (e) {
        log('cached_data_error', settingId);
        console.error(e);
      }
    } else {
      log('no_cached_data', settingId);
    }
  }
}

/**
 * 检查配置是否加载成功
 */
function checkScript() {
  var settingId = getSettingId();
  var data = getSettingData();
  if (!settingId) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('你使用了setting的方法，但没有在webpack中加入setting-vue-webpack-plugin。');
    }
    return;
  }
  if (!data) {
    log('script_load_error', settingId);
    // script有千分之一的概率加载失败，这里做一次切换接口重试的逻辑
    data = syncXhr("//".concat(settingCgiHost, "/x/setting-cgi/route/json/").concat(settingId, "/"));
    if (data) {
      setSettingData(data);
      log('script_repeat_load_success', settingId);
    } else {
      log('script_repeat_load_error', settingId);
    }
    return;
  }
  log('script_load_success', settingId);
}
try {
  checkScript();
  checkCache();
  checkPreview();
} catch (err) {
  var msg = err.toString();

  // safari设置隐身模式时，localStorage会抛出错误
  var ignoreMsgs = ['Error: QUOTA_EXCEEDED_ERR: DOM Exception 22', 'Error: QuotaExceededError: DOM Exception 22', 'QuotaExceededError (DOM Exception 22): The quota has been exceeded.'];
  if (!ignoreMsgs.find(function (item) {
    return item === msg;
  })) {
    log('error ' + err);
  }
}
function getDefaultValueByConfig(config) {
  var val = {};
  var _loop = function _loop(key) {
    var item = config[key];

    // 对简单类型进行处理
    if (typeof item === 'number') {
      config[key] = item = {
        type: 'number',
        default: item
      };
    } else if (typeof item === 'boolean') {
      config[key] = item = {
        type: 'boolean',
        default: item
      };
    } else if (typeof item === 'string') {
      var isImage = ['//puep.qpic.cn/', '//puui.qpic.cn/'].find(function (host) {
        return item.indexOf(host) >= 0;
      });
      config[key] = item = {
        type: isImage ? 'image' : 'string',
        default: item
      };
    }
    val[key] = config[key].default;
    if (item.type === 'array') {
      val[key] = val[key] || [];
    } else if (item.type === 'object') {
      val[key] = getDefaultValueByConfig(item.properties);
    } else if (item.type === 'datetime') {
      // datetime类型提供成Date
      if (typeof val[key] === 'string') {
        val[key] = parseDate(val[key], 'yyyy-MM-dd HH:mm:ss');
      } else if (typeof val[key] === 'number') {
        val[key] = new Date(val[key]);
      }
    }
  };
  for (var key in config) {
    _loop(key);
  }
  return val;
}
export default function getSettingValue(settingKey, settingConfig) {
  var settingData = getSettingData();
  var settingValue = settingData && settingData[settingKey];
  var defaultSettingValue = getDefaultValueByConfig(settingConfig);
  if (settingValue) {
    Object.keys(defaultSettingValue).forEach(function (key) {
      if (typeof settingValue[key] === 'undefined') {
        settingValue[key] = defaultSettingValue[key];
      }
    });
    return Object.assign({}, settingValue);
  } else {
    return Object.assign({}, defaultSettingValue);
  }
}